import { SystemlogModel } from '../../models'
import { SystemlogDto } from '../dto'

const systemlogToModelTransformer = (values: SystemlogDto): SystemlogModel[] => {
  return values.id.map((id, index) => ({
    id,
    count: values.count[index] || 0,
    createdAt: values.createdAt[index] || '',
    deviceLinkId: values.deviceLinkId[index] || -1,
    errorCode: Number(values.errorCode[index]) || -1,
    errorType: values.errorType[index] || 'NOTICE',
    errorSource: values.errorSource[index] || '',
    isResolved: values.isResolved[index] || false,
    resolvedBy: values.resolvedBy[index] || -1,
    resolvedReason: values.resolvedReason[index] || '',
    timestamp: values.timestamp[index] || '',
    updatedAt: values.updatedAt[index] || '',
    resolvedAt: values.resolvedAt[index] || '',
  }))
}

export default systemlogToModelTransformer
